import { useParams } from "react-router-dom";
import CustomerIcon from "assets/customer.svg?react";
import { SidebarLayout } from "src/layout/SidebarLayout/SidebarLayout";

export const CustomersSection = () => {
  const { projectId } = useParams();

  return (
    <SidebarLayout.SidebarMainLayout.ListNavLink
      to={`/projects/${projectId}/customers`}
      label="Customers"
      iconSvg={<CustomerIcon width={24} height={24} />}
    />
  );
};
